module.exports = __webpack_public_path__ + "static/media/nft-27.3127b2ae.jpg";